module.exports = __webpack_public_path__ + "static/media/maria1.a895e09e.mp3";